const demoData = 'demoData';
const InternalEventUploader = 'InternalEventUploader';

export const GENERATE_DEMO_ACCOUNT_REQUEST = `${demoData}/GENERATE_DEMO_ACCOUNT_REQUEST` as const;
export const UPLOAD_EVENT_REQUEST = `${InternalEventUploader}/UPLOAD_EVENT_REQUEST` as const;
export const UPLOAD_EVENT_RESPONSE = `${InternalEventUploader}/UPLOAD_EVENT_RESPONSE` as const;
